export default {
    importSubUser_title: 'Importar Usuarios',
    importSubUser_button: 'Importar',
    importSubUser_cancel: 'Cancelar',
    importSubUser_semicolon: 'Punto y coma (;)',
    importSubUser_comma: 'Coma (,)',
    importSubUser_selectDelimiter: 'Seleccionar',
    importSubUser_delimiter: 'Delimitador',
    importSubUser_started: 'Importación iniciada exitosamente',
    importSubUser_completed: 'Importación completada exitosamente',
    importSubUser_error_required: 'El archivo es requerido',
    importSubUser_error_delimiter: 'El delimitador es requerido',
    importSubUser_downloadTemplate: 'Descargar Plantilla',
    importSubUser_file: 'Archivo',
    importSubUser_chooseFile: 'Elegir Archivo',
    importSubUser_support_message: 'Solo se admite formato CSV',
    importSubUser_max: 'Máximo',
    importSubUser_maxSizeFile: 'Tamaño máximo de archivo: 5MB',
    importSubUser_instructions: 'Nota Importante: Las columnas ID, Nombre de Usuario y Correo Electrónico son obligatorias para las actualizaciones, pero no se pueden modificar. Deben coincidir con los registros de usuario existentes; Esta función no admite la creación de usuarios en este momento. Por favor, realice una exportación de tabla sin editar el valor de la columna ID para mantener la referencia de registro para las actualizaciones de usuario.',
    users_import_error_US01: 'Archivo CSV vacío: El archivo no contiene filas de datos. Por favor, agregue al menos una fila con información del usuario.',
    users_import_error_US02: 'Error en el formato CSV: La columna ID es obligatoria para las actualizaciones de usuarios.',
    users_import_error_US03: 'No se encontraron filas de datos válidas: Las columnas ID, Nombre, Apellido, Correo Electrónico, Nombre de Usuario, Rol y Etiquetas no pueden estar vacías en todas las filas.',
};